import { css as emotionCSS } from '@emotion/react';
import type { CSSInterpolation } from '@emotion/serialize';

export const css = (...args: Array<CSSInterpolation>) => {
  return emotionCSS(...args);
};
